export default __webpack_public_path__ + "static/media/tree.55f3054c.svg";